import { styled } from "../../theme";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";

export const FlagContainer = styled.div<{ bg: string }>`
  ${({ bg }) => `background-image: url(${bg})`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 2em;
  height: 2em;
`;
export const FlagSelect = styled(Select)`
  font-size: 4em;
  border-color: red;
  &::before,
  &::after {
    border-bottom: inherit !important;
  }
`;
